import { InlineEditableField } from 'app/components/Common/EditPage/InlineEditableField';
import React from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { editableFields } from '../../editUtils';
import { selectEditableData } from '../../../../../../store/redux-store/placement-details/selectors';
import { CustomTextField } from '../CustomComponents/CustomTextField';
import { pageAttributesActions } from '../store/placementPageAttributes.redux';
import { selectEditStatus, selectPageAttributes } from '../store/placementPageAttributes.selector';
import { ActionAccessorHook } from './ActionAccessorHook';

export const BestTimeToCall = ({ id }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { control } = useFormContext();
  const { bestTimeToCall: status } = useSelector(selectEditStatus);
  const { editOrderStack } = useSelector(selectPageAttributes);
  const { bestTimeToCall: defaultValue } = useSelector(selectEditableData);

   /** Code: useWatch has been used to retain value while avoidParentForm is triggered in Placement screen wrapper */
  const  bestTimeToCall = useWatch<string>({ name: 'bestTimeToCall', control });

  const undoChecker = () => !editOrderStack.some(key => key === 'bestTimeToCall');
  return (
    <Controller
      control={control}
      name="bestTimeToCall"
      render={({ field: { onChange, ...rest } }) => (
        <>
          {/** Component is used to access inaccessible methods from react-hook-form Controller
           * to invoke actions - say undo action */}
          <ActionAccessorHook
            actionChecker={undoChecker}
            accessAction={() => onChange(defaultValue)}
            hookDependancies={[editOrderStack]}
          />
          <InlineEditableField
            {...rest}
            id={id}
            label={bestTimeToCall}
            tooltipText={status.disabled ? t('placement.profile.edit.disableText') : ''}
            inputProps={{ value: bestTimeToCall, minWidth: 80, renderedFromInlineEditor: true }}
            Control={CustomTextField}
            onChange={newValue => {
              onChange(newValue);
              dispatch(pageAttributesActions.pushToEditOrderStack(editableFields.bestTimeToCall));
            }}
            setCurrentFocus={state => dispatch(pageAttributesActions.setCurrentFocus(state !== null ? id : null))}
            {...status}
          />
        </>
      )}
    />
  );
};
